import React from 'react';
// import { withCookies } from 'react-cookie';
import { connect } from 'react-redux'
import * as faqAction from './../../actionSMB/faqAction';
// import FaqData from './faqData';
import Modal from 'react-responsive-modal';
import { updatePageLogs, checktime, catchJSException } from './../../serviceSMB/logService';
import { updateSCTags } from './../../serviceSMB/dtmTag';
import { getVZDLInit } from './../../serviceSMB/vzdl';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
// import { Utils } from '../../util/utils';

export class Faq extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {

            openFlag: false,
            expanded: false,
            close: 0
        }
    }
    openModelBox = (evt) => {
        try {
            updateSCTags("faqs");
            getVZDLInit(this.props.appState.visitId,"","","","faq");
            this.setState({
                openFlag: true
            })
        } catch (ex) {
            catchJSException('faq_index', this.props.appState.visitId, 'openModelBox', ex);
        }
    }

    onCloseModal = () => {
        try {
            updateSCTags("close faqs");
            this.setState({ openFlag: false });
        } catch (ex) {
            catchJSException('faq_index', this.props.appState.visitId, 'onCloseModal', ex);
        }
    };
    componentWillMount() {
        // faqAction.getFaqFromJSON(this.props.dispatch)
        var faqData=window.faqresp
        if (faqData !== undefined && faqData !== "" && faqData !== null  )
        {
            this.props.dispatch({ type: 'FAQFROMAPI', value: faqData.description})
            window.faqresp
        }
        else{
            faqAction.getFaqFromApi(this.props.appState.visitId, this.props.dispatch)
        }
        checktime(this.callCheckTime('WillMount'));
        this.processPageAfterVisitID()
    }
    processPageAfterVisitID = () => {
        try {
            updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            checktime(this.callCheckTime('Mount'));
            // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
        }
        catch (ex) {
            catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
        }
    }
    callCheckTime = ((pagestate) => {
        return {
            page: 'FAQ',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    showAns = (Index) => {
        try {
            let id = document.getElementById(Index)
            if (id.className === "m_accordion-summary m_single") {
                let content = id.textContent && id.textContent.trim().split(" ").splice(-3).join(" ");
                updateSCTags("faq: " + content);
                id.className = "m_accordion-summary m_single open"
                if (this.state.close !== 0) {
                    document.getElementById(this.state.close).className = "m_accordion-summary m_single"
                }
                this.setState({
                    close: Index
                })
            }
            else if (id.className === "m_accordion-summary m_single open") {
                id.className = "m_accordion-summary m_single"
                this.setState({
                    close: 0
                })
            }
        } catch (ex) {
            catchJSException('faq', "", 'showAns', ex);
        }
    }
    htmlParserTransform = (node, index) => {
        if (node.type === 'tag' && node.name === 'a') {
            node.attribs.style = "display:none"
            return convertNodeToElement(node, index, this.htmlParserTransform);
        }
        else if (node.type === "tag" && node.name === "li" && node.attribs.class === "m_accordion-summary m_single") { // a tag named a
            node.attribs.class = " "
            return (
                <li id={"id"+index} class="m_accordion-summary m_single"  onClick={() => this.showAns("id"+index)} >
                    <span pointerEvents="none">
                        {convertNodeToElement(node, index, this.htmlParserTransform)}
                    </span>
                </li>
            )
        }
        else if (node.type === "tag" && node.name === "button") {
            return (
                <button onClick={() => this.onCloseModal()} className="button center medium-p-auto  margin-bottom-medium no-focus-effect" data-close-modal="" tabIndex="0" >Close</button>
            )
        }
        else if (node.type === "tag" && node.name === "h4") {
            return (
                <h2>Q &amp; A</h2>
            )
        }
        // else if (node.type === "tag" && node.name === "div" && node.attribs.class === "w_modal m_medium m_modal-width") {
        //     node.attribs.style = "max-height: 268.2px;top: 51%;margin-top: -34px;"
        //     return convertNodeToElement(node, index, this.htmlParserTransform);
        // }

    }

    render() {
        const { openFlag } = this.state;
        // let faqData = <FaqData appState={this.props.appState} />
        let content
        if (this.props.faqState.faqExp) {
            content = this.props.faqState.faqExp
            content = content.replace(/class="w_modal m_medium m_modal-width" data-modal="FAQmodal"/g, ' data-modal="FAQmodal"')
        }
        return (
            <div className="faq">
                <div data-open-modal="FAQmodal" tabIndex="0" aria-label="Opens a Modal" aria-haspopup="true">
                    <span onClick={this.openModelBox} className="vzicon middle icon-question-answer"></span>
                    <span onClick={this.openModelBox} className="faq-text bold padding-left-micro">Frequently asked questions</span>
                    <Modal open={openFlag} onClose={() => this.onCloseModal()} center>
                        {ReactHtmlParser(content, { transform: this.htmlParserTransform })}
                    </Modal>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {

    return {

        faqState: state.faqDetailsSMB,
        appState: state.appSMB

    }
}
export default connect(
    mapStateToProps
)(Faq);